<div class="app-loading-state" [ngClass]="'app-loading-state--' + size">
  <span class="app-loading-state__ring"></span>
  <p *ngIf="text" class="app-loading-state__text">{{ text }}</p>
</div>
